import { get } from 'lodash';
import { HydrateWidgetFn } from '../../../../../hydrate/IHydrationContext';
import { IRepeatableWidget } from './IRepeatableWidget';

/**
 * Per i widget ripetibili dobbiamo ritornare N campi, moltiplicando gli M widget
 * (presenti in `widget.children`) per ogni riga della lista, che essendo un
 * array può possono R elementi: quindi N = M x R
 */
export const hydrateRepeatableWidget: HydrateWidgetFn<IRepeatableWidget> = (
  { context, widget, path },
  hydrateChildren,
) => {
  const value = get(context.values, path);
  if (!value || !Array.isArray(value) || value.length === 0) {
    return {
      children: null as any,
      hydratedItems: [],
    };
  }

  return {
    children: null as any,
    hydratedItems: value.map((itemValue, index) => {
      const itemPath = `${path}[${index}].`;
      const childContext = {
        ...context,
        prefix: itemPath,
      };

      return {
        value: itemValue,
        index,
        children: hydrateChildren(childContext, widget.children),
      };
    }),
  };
};
